import React from "react";
import { Panel } from "../../components/ui/dashboard";

const Fleet: React.FC = () => {
  return (
    <div className="p-4 md:p-6 grid grid-cols-1 xl:grid-cols-2 gap-4">
      <Panel title="Driver Management" subtitle="Add, update, assign drivers">
        <div className="space-y-2">
          <input className="w-full border rounded-lg px-3 py-2 text-sm" placeholder="Driver Name" />
          <input className="w-full border rounded-lg px-3 py-2 text-sm" placeholder="License Number" />
          <select className="w-full border rounded-lg px-3 py-2 text-sm">
            <option>Status: available</option>
            <option>on_trip</option>
            <option>off_duty</option>
          </select>
          <button className="px-3 py-2 rounded-lg text-sm bg-slate-900 text-white">Save Driver</button>
        </div>
      </Panel>

      <Panel title="Vehicle Management" subtitle="Register and track vehicles">
        <div className="space-y-2">
          <input className="w-full border rounded-lg px-3 py-2 text-sm" placeholder="Registration Number" />
          <select className="w-full border rounded-lg px-3 py-2 text-sm">
            <option>truck</option>
            <option>van</option>
            <option>tanker</option>
            <option>trailer</option>
          </select>
          <input className="w-full border rounded-lg px-3 py-2 text-sm" placeholder="Capacity (kg)" />
          <button className="px-3 py-2 rounded-lg text-sm bg-slate-900 text-white">Save Vehicle</button>
        </div>
      </Panel>
    </div>
  );
};

export default Fleet;